
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.4 0H3.6C1.602 0 .018 1.558.018 3.5L0 24.5C0 26.442 1.602 28 3.6 28h28.8c1.998 0 3.6-1.558 3.6-3.5v-21C36 1.558 34.398 0 32.4 0zm0 24.5H3.6V14h28.8v10.5zm0-17.5H3.6V3.5h28.8V7z","fill":"#0095DA"}})])
          )
        }
      }
    